import { Route } from 'react-router-dom';
import SilentRefreshModal from './SilentRefreshModal';
import { useAuth } from 'react-oidc-context';
import NotAuthorized from './NotAuthorized';
import LoadingPage from 'components/LoadingPage';
import { BaseRoute } from 'constants/routes';
import { AuthenticationStatus, LocalStorageKeys } from './modules/constants';

export const PrivateRoute = (props) => {
  const { component: Component, ...rest } = props;
  const auth = useAuth();

  if (auth.isLoading) {
    return <LoadingPage />;
  }

  const isAuthenticated = () => {
    if (auth.isAuthenticated) {
      const user_authenticated = localStorage.getItem(LocalStorageKeys.user_authenticated);
      const user_access_token = localStorage.getItem(LocalStorageKeys.user_access_token);
      if (
        user_authenticated == AuthenticationStatus.Authenticated &&
        user_access_token
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      // Set current page
      const originalRequestURL = window.location.href.split(`${BaseRoute}/`)[1];
      if (
        originalRequestURL &&
        originalRequestURL.indexOf('login') < 0 &&
        originalRequestURL.indexOf('logout') < 0 &&
        !originalRequestURL.startsWith('auth')
      ) {
        // Store the original request url in the local storage
        localStorage.setItem(LocalStorageKeys.originalRequestURL, originalRequestURL);
      }
    }
    return false;
  };
  return (
    <Route
      {...rest}
      render={(innerprops) => {
        return isAuthenticated() ? (
          <>
            <Component {...innerprops} />
            <SilentRefreshModal />
          </>
        ) : (
          <NotAuthorized />
        );
      }}
    />
  );
};

export default PrivateRoute;
